<!--
 * @Author: zwcong
 * @Description: 空状态
 * @Date: 2021-07-31
 * @LastEditTime: 2022-03-30 11:59:09
 * @FilePath: /teacher-h5/src/components/ComNull/ComNull.vue
 *
-->

<template>
  <div class="null-container">
    <img v-if="showImg" src="@/static/images/null/empty.png" :style="{width: `${imgWidth}px`}" />
    <p>{{ desc }}</p>
  </div>
</template>
<script>
export default {
  name: 'ComNull',
  props: {
    // 描述
    desc: {
      type: String,
      default: ''
    },
    imgWidth: {
      type: Number,
      default: 200
    },
    showImg: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/static/css/colors.less';
.null-container{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;

  img{
    width: 200px;
  }

  p{
    font-size: 14px;
    line-height: 22px;
    color: @gray-3;
    // margin-bottom: 80px;
    margin-top: 20px;
  }
}
</style>